import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@material-ui/lab";

export const SpeedDialList = ({
  classes,
  handleSpeedDialClose,
  handleSpeedDialOpen,
  isSpeedDialOpen,
  actions,
}) => (
  <SpeedDial
    ariaLabel="Speed Dial"
    className={classes.speedDial}
    icon={<SpeedDialIcon />}
    onClose={handleSpeedDialClose}
    onOpen={handleSpeedDialOpen}
    open={isSpeedDialOpen}
  >
    {actions.map((action) => (
      <SpeedDialAction
        key={action.name}
        icon={action.icon}
        tooltipTitle={action.name}
        {...(classes?.speedDialAction != null
          ? { classes: { fab: classes.speedDialAction } }
          : {})}
        tooltipOpen
        onClick={action.onClick}
      />
    ))}
  </SpeedDial>
);
